export enum PaymentStatus {
  PENDING = 'PENDING',
  WAITING = 'WAITING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}
